'use strict'

import { BaseView } from '../../../shared/utils/baseComponent'
import css from './list.styles.scss'
import template from './list.template.pug'

export class CustomerTasksitesController extends BaseView {
  constructor($mdSidenav, $state, $mdDialog, $filter, $element, $mdToast, SessionService) {
    'ngInject'
    super($element)
    Object.assign(this, { $mdSidenav, $state, $mdDialog, $filter, $mdToast, SessionService })
    this.eyeCatcher = require('../../assets/places.svg')

    this.states = ['NEW', 'ACCEPTED'] // In this order
    this.resultStep = {
      NEW: 50,
      ACCEPTED: 50,
    }
    this.resultCount = JSON.parse(JSON.stringify(this.resultStep)) // deep copy
    this.slicedTasksites = {}
  }

  $onInit() {
    if (this.customer.blocked) this.openCustomerBlockedToast()
  }

  $onChanges(changes) {
    if (changes.tasksites) {
      this.sliceTasksites()
    }
  }

  openCustomerBlockedToast() {
    const toast = this.$mdToast.blockedToast({
      hideDelay: 0, // stays open until closed manually
    })

    return this.$mdToast.show(toast)
  }

  openCreateOrderDialog() {
    const orderCreateDialog = this.$mdDialog.orderCreateDialog({
      fullscreen: true,
      resolve: {
        order: (OrderFactory) => {
          'ngInject'
          const order = new OrderFactory({ customer: this.customer })
          return order.init()
        },
      },
      locals: {
        createNewTaskSite: true,
      },
    })

    return this.$mdDialog.show(orderCreateDialog).then((tasksite) => {
      this.customer.addTasksite(tasksite)
      this.$state.reload()
    })
  }

  /* get the count of tasksites of the given state which will be shown in the next stap */
  getNextStepSize(state) {
    return Math.min(this.getRemainingTasksiteCount(state), this.resultStep[state])
  }

  /* how many taksites of the given state are hidden? */
  getRemainingTasksiteCount(state) {
    return this.$filter('filter')(this.tasksites, { status: state }).length - this.resultCount[state]
  }

  /* display one more bunch of tasksites of the given state */
  showMoreTasksites(state) {
    this.resultCount[state] += this.resultStep[state]
    this.sliceTasksites()
  }

  sliceTasksites() {
    this.states.forEach((s) => {
      this.slicedTasksites[s] = this.$filter('filter')(this.tasksites, { status: s }).slice(0, this.resultCount[s])
    })
  }

  search() {
    const searchDialog = this.$mdDialog.tasksiteSearchDialog({
      fullscreen: true,
      locals: {
        tasksites: this.tasksites,
      },
    })

    return this.$mdDialog.show(searchDialog)
  }

  getCurrentYear() {
    return new Date().getFullYear()
  }
}

export const customerTasksitesComponent = {
  controller: CustomerTasksitesController,
  bindings: {
    customer: '<',
    tasksites: '<',
  },
  template: template({ css }),
}



// WEBPACK FOOTER //
// ./app/tasksites/containers/list/list.component.js